<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppMaxTagSelect',
})
</script>
<template>
  <a-select ref="selectRef" :maxTagCount="3" v-bind="attrs" v-on="attrs" class="w-full">
    <template #maxTagPlaceholder="value">
      <a-tooltip>
        <template #title>
          <div v-for="item in value" :key="item.label">
            {{ item.label }}
          </div>
        </template>
        <span>+ {{ value.length }} ...</span>
      </a-tooltip>
    </template>
    <slot />
  </a-select>
</template>

<script setup lang="ts" name="AppMaxTagSelect">
  import { ref, useAttrs, defineExpose } from 'vue'
  const attrs = useAttrs()
  const selectRef = ref(null)
  defineExpose({
    selectRef,
  })
</script>
